"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toMarkdown = void 0;
const md_utils_1 = require("../../../export/md.utils");
const rich_text_1 = require("@vedalib/rich-text");
const toMarkdown = (element, context) => {
    if (!element.value) {
        return '';
    }
    const sections = [];
    sections.push('**Hotspot Question**\n');
    if (element.value.image) {
        const url = (0, md_utils_1.getFileUrl)(element.value.image, context);
        if (url) {
            sections.push(`![Hotspot Image](${url})`);
        }
    }
    if (element.value.response) {
        sections.push(`Response type: ${element.value.response}`);
    }
    if (element.value.generalFeedback) {
        const feedbackParts = [];
        if (element.value.generalFeedback.info) {
            const infoText = (0, rich_text_1.slateToMarkdown)(element.value.generalFeedback.info, {
                allowHtmlStyles: context.withStyle,
                allowAlignment: context.withStyle,
                allowCaptionHtml: context.withStyle,
            }).trim();
            if (infoText) {
                feedbackParts.push(`**Info:** ${infoText}`);
            }
        }
        if (element.value.generalFeedback.success) {
            const successText = (0, rich_text_1.slateToMarkdown)(element.value.generalFeedback.success, {
                allowHtmlStyles: context.withStyle,
                allowAlignment: context.withStyle,
                allowCaptionHtml: context.withStyle,
            }).trim();
            if (successText) {
                feedbackParts.push(`**Correct:** ${successText}`);
            }
        }
        if (element.value.generalFeedback.fail) {
            const failText = (0, rich_text_1.slateToMarkdown)(element.value.generalFeedback.fail, {
                allowHtmlStyles: context.withStyle,
                allowAlignment: context.withStyle,
                allowCaptionHtml: context.withStyle,
            }).trim();
            if (failText) {
                feedbackParts.push(`**Incorrect:** ${failText}`);
            }
        }
        if (feedbackParts.length > 0) {
            sections.push(feedbackParts.join('\n\n'));
        }
    }
    if (sections.length === 1) {
        return '';
    }
    return sections.join('\n\n') + '\n\n';
};
exports.toMarkdown = toMarkdown;
